module.exports = __webpack_public_path__ + "img/msg.c7de5589.png";